import Phaser from 'phaser';

export default class GameOverScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOverScene' });
  }

  create() {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#0A0505');

    // Game Over text
    this.add.text(width / 2, height * 0.3, 'DEFEATED', {
      font: 'bold 64px Playfair Display',
      fill: '#FF6B6B'
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.45, 'Your journey ends here...', {
      font: '24px Manrope',
      fill: '#AAAAAA'
    }).setOrigin(0.5);

    this.add.text(width / 2, height * 0.52, 'But the Ten Parts of Truth remain scattered.', {
      font: 'italic 18px Manrope',
      fill: '#666666'
    }).setOrigin(0.5);

    // Options
    const retryBtn = this.add.text(width / 2, height * 0.65, 'TRY AGAIN', {
      font: '28px Manrope',
      fill: '#FFFFFF',
      backgroundColor: '#5D1916',
      padding: { x: 30, y: 15 }
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    retryBtn.on('pointerover', () => retryBtn.setStyle({ fill: '#FFD700' }));
    retryBtn.on('pointerout', () => retryBtn.setStyle({ fill: '#FFFFFF' }));
    retryBtn.on('pointerdown', () => {
      this.cameras.main.fadeOut(500);
      this.time.delayedCall(500, () => this.scene.start('GameScene'));
    });

    const menuBtn = this.add.text(width / 2, height * 0.78, 'MAIN MENU', {
      font: '20px Manrope',
      fill: '#AAAAAA'
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    menuBtn.on('pointerdown', () => {
      this.cameras.main.fadeOut(500);
      this.time.delayedCall(500, () => this.scene.start('TitleScene'));
    });

    this.cameras.main.fadeIn(1000);
  }
}
